import React from 'react';

export default function (props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M5.34625 19.5V10.398L2.402 12.625L1.5 11.4288L12 3.5L16.173 6.6365V4.5H18.6152V8.49425L22.5095 11.4288L21.6077 12.625L18.6635 10.398V19.5H13.1155V13.8845H10.8845V19.5H5.34625ZM6.84625 18H9.38475V12.3848H14.6152V18H17.1635V9.26725L12 5.39025L6.84625 9.26725V18Z"
        fill="#919699"
      />
    </svg>
  );
}
